import Vue from "vue";

import App from "./App.vue";
import "./registerServiceWorker";

import router from "./router";
import store from "./stores/index";

Vue.config.productionTip = false;

import { SentryDSN, } from "./config";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
Sentry.init({
    Vue,
    "dsn": SentryDSN,
    "integrations": [new Integrations.BrowserTracing()],
    "tracesSampleRate": 1.0,
});

import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();

import VueStickyEvent from "./plugins/directives/sticky-event";
Vue.use(VueStickyEvent);

import "vue-swatches/dist/vue-swatches.css";

import "./init/font-awesome";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
Vue.component("font-awesome-icon", FontAwesomeIcon);

import vue2GoogleMap from "./init/vue2-google-maps";
Vue.use(vue2GoogleMap);

import {
    capitalize,
    currency
} from "./plugins/filters";
Vue.use(capitalize);
Vue.use(currency);

import vueDateFnsFormatter from "./plugins/date-fns-formatter/index";
Vue.use(vueDateFnsFormatter);

import Meta from "vue-meta";
Vue.use(Meta);

import {
    baseUrl,
    apiUrl,
    apiVersion,
    GoogleClientId,
    reCAPTCHAKey,
    roleMap,
} from "./config";
import VueConfigurator from "./plugins/configurator/index";
Vue.use(
    VueConfigurator,
    {
        baseUrl,
        apiUrl,
        apiVersion,
        GoogleClientId,
        reCAPTCHAKey,
        roleMap,
    }
);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
